export const GET_TRANSFER_PACK = "app/TRANSFER_PACK/GET_TRANSFER_PACK";
export const GET_TRANSFER_PACK_SUCCESS =
  "app/TRANSFER_PACK/GET_TRANSFER_PACK_SUCCESS";
export const GET_TRANSFER_PACK_FAILURE =
  "app/TRANSFER_PACK/GET_TRANSFER_PACK_FAILURE";
